/**
 * REINSTATE: Disabled 2026-08 per BFF request (may be reinstated): free-text gram entry
 * with round-up-to-nearest-variant logic. Preserved for when client re-enables enable_gram_input.
 */
if (typeof customElements.get('bff-gram-picker') === 'undefined') {
  class BffGramPicker extends HTMLElement {
    #debounceTimer = null;

    connectedCallback() {
      if (this._initialized) {
        return;
      }
      this._initialized = true;

      this.select = this.querySelector('select[data-js-product-variant-container]');
      this.input = this.querySelector('[data-bff-gram-input]');
      if (!this.select || !this.input) {
        return;
      }

      this.gramOptions = [...this.select.options]
        .filter((option) => option.dataset.grams && !option.hasAttribute('data-disabled'))
        .map((option) => ({
          option,
          grams: parseFloat(option.dataset.grams, 10),
          value: option.value,
        }))
        .filter((entry) => Number.isFinite(entry.grams))
        .sort((a, b) => a.grams - b.grams);

      const gramField = this.querySelector('.product-variant__gram-field');
      if (!this.gramOptions.length) {
        gramField?.remove();
        return;
      }

      this.input.addEventListener('input', this.#onInput.bind(this));
      this.input.addEventListener('blur', this.#onInput.bind(this));
      this.select.addEventListener('change', this.#onSelectChange.bind(this));
      this.#selectDefaultGramVariant();
      this.#syncInputFromSelect();
    }

    #selectDefaultGramVariant() {
      const preferred = this.gramOptions.find((entry) => entry.grams === 100);
      if (!preferred) {
        return;
      }

      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      const preferredVariantId = preferred.option.dataset.variantId;
      const needsReset =
        this.select.value !== preferred.value ||
        (urlVariant && urlVariant !== preferredVariantId);

      if (needsReset) {
        this.select.value = preferred.value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    #onInput() {
      window.clearTimeout(this.#debounceTimer);
      this.#debounceTimer = window.setTimeout(() => {
        this.#applyGramInput();
      }, 200);
    }

    #applyGramInput() {
      const raw = this.input.value.trim();
      if (raw === '') {
        return;
      }

      const requested = parseFloat(raw, 10);
      if (!Number.isFinite(requested) || requested <= 0) {
        return;
      }

      const match = this.#findVariantForGrams(requested);
      if (!match || this.select.value === match.value) {
        return;
      }

      this.select.value = match.value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    #findVariantForGrams(requested) {
      return (
        this.gramOptions.find((entry) => entry.grams >= requested) ||
        this.gramOptions[this.gramOptions.length - 1]
      );
    }

    #onSelectChange() {
      if (document.activeElement === this.input) {
        return;
      }
      this.#syncInputFromSelect();
    }

    #syncInputFromSelect() {
      const selected = this.select.selectedOptions[0];
      if (!selected?.dataset.grams) {
        return;
      }
      this.input.value = selected.dataset.grams;
    }
  }

  customElements.define('bff-gram-picker', BffGramPicker);
}
